// extracted by mini-css-extract-plugin
module.exports = {"input-card":"styles_input-card__VTwaq","moneyInputWrapper":"styles_moneyInputWrapper__bZC1Q","cifrao":"styles_cifrao__icabP","moneyInput":"styles_moneyInput__rgDge"};